import {
  BarChartOutlined as MetricsIcon,
  PersonAddOutlined as LeadsIcon,
  PeopleOutlined as ClientsIcon,
  SettingsOutlined as SettingsIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

// Single source of truth for the app's top-level sections, shared by
// BottomNavBar (mobile) and DesktopNav (desktop sidebar).
const useNavigationItems = () => {
  const { t } = useTranslation();

  return [
    { path: '/leads', label: t('nav.leads'), icon: <LeadsIcon /> },
    { path: '/clients', label: t('nav.clients'), icon: <ClientsIcon /> },
    { path: '/metrics', label: t('nav.metrics'), icon: <MetricsIcon /> },
    { path: '/settings', label: t('nav.settings'), icon: <SettingsIcon /> },
  ];
};

export default useNavigationItems;
